import React from 'react'
import {
  FeedDetailHeader,
  FeedUserInfo,
  FeedUserImgArea,
  FeedUserImg,
  FeedTopInfoArea,
  FeedUserName,
  FeedDescription,
} from './style'
import appInfoContainer from 'auth/appInfoContainer'
import DotButton from 'components/presenters/button/DotButton'

const FeedDetailTop = ({ feedItem, userInfo, handleBottomModalState }) => {
  return (
    <FeedDetailHeader>
      <FeedUserInfo to={`/task/friend/${feedItem['user_no']}/list`}>
        <FeedUserImgArea>
          <FeedUserImg
            src={`${appInfoContainer.imagePath}/user_profile_img/${feedItem['profile_img']}`}
          />
        </FeedUserImgArea>
      </FeedUserInfo>
      <FeedTopInfoArea>
        <FeedUserName>{feedItem['nickname']}</FeedUserName>
        <FeedDescription>{feedItem['title']}</FeedDescription>
      </FeedTopInfoArea>
      <DotButton onClick={() => handleBottomModalState(feedItem)} />
    </FeedDetailHeader>
  )
}

export default FeedDetailTop
